<div class="col-12">
  <div class="col-12 data-monitor-page">
    <!-- 全画面のモーダル -->
    <full-modal
      id="play-dm-modal"
      :contentId="modalContentId()"
      :showModal="showModal"
    />

    <!-- vue3.5以降でないとdeferが使用できないため、移動先の描画完了までteleport自体を描画しない -->
    <wrapped-teleport :destinationId="graphSettingsDestinationId()" :noRenderTeleport="!measureMounted" :disabled="!showModal">
      <div class="one-liner-btns">
        <!-- メモボタン -->
        <div class="left-side-btn">
          <b-button :class="showModal ? '' : 'ml-2'" variant="primary" size="sm" @click="parentOpenMemoModal">
            {{ $t('message.button_vehicle_dtc_note_modal') }}
          </b-button>
          <!-- CSVエクスポートボタン -->
          <b-button :class="showModal ? '' : 'ml-2'" variant="primary" size="sm" :disabled="inPlaying" @click="csvExport" @contextmenu.once="() => {debugCsvExport ? debugCsvExport() : ''}">
            {{ $t('message.file_export') }}
          </b-button>
        </div>
        <!-- グラフ設定ボタン -->
        <div class="right-side-btn">
          <b-button
            :class="showModal ? '' : 'ml-2'"
            variant="primary"
            size="sm"
            @click="handleConfigureGraph"
            :disabled="btnDisabled"
          >
            {{ $t('individual.button_data_monitor_graph_config') }}
          </b-button>

          <!-- 最大化ボタン -->
          <no-text-svg-button
            v-if="!showModal"
            :class="`ml-2 ${BUTTON_TYPE.RIGHT_TOP}`"
            variant="outline-info"
            :iconKey="ICON_KEY.MAXIMUM"
            @click="maximum()"
          />
          <!-- 最小化ボタン -->
          <no-text-svg-button
            v-else
            :class="BUTTON_TYPE.RIGHT_TOP"
            variant="outline-info"
            :iconKey="ICON_KEY.MINIMUM"
            @click="minimum()"
          />
        </div>
      </div>
    </wrapped-teleport>

    <teleport :to="`#${modalContentId()}`" :disabled="!modalContentId() || !showModal">
      <div v-if="!currentPercentage || currentPercentage !== 100" class="recollection-progress-bar">
      <!-- <div class="recollection-progress-bar"> -->
        <div class="progress" role="progressbar" aria-label="progress-area" aria-valuenow="currentPercentage" aria-valuemin="0" aria-valuemax="100">
          <div class="progress-bar" :style="{'width': currentPercentage + '%'}">{{ currentPercentage + ' %' }}</div>
        </div>
      </div>
    </teleport>

    <!-- 再生データのリストやグラフ -->
    <data-monitor
      class="{'dm-area': showSelect}"
      ref="data_monitor"
      parentName="data_recollection"
      :showSelect="showSelect"
      :inPlaying="inPlaying"
      :dataMonitorFunctionSettings="dataMonitorFunctionSettings"
      :showModal="showModal"
      :modalContentId="modalContentId()"
      :graphSettingsDestinationId="graphSettingsDestinationId()"
      @toggle-playing="togglePlaying"
      @change-check-value = "changeCheckValue"
      @back-select="backSelect"
      @update-total-count="updateTotalCount"
      @maximum="maximum"
      @measure-mounted="measureMountedEvent"
    />
  </div>
  <processing-view :processing="processing"></processing-view>
</div>